/**
 * Decodifica un "encoded polyline" de Google (el formato en el que el backend
 * manda la geometría de las rutinas, ver `dashboard-statistics/recent-routines`)
 * a una lista de pares `[lat, lng]`.
 *
 * Es el mismo algoritmo que `google.maps.geometry.encoding.decodePath` o
 * `@mapbox/polyline`, implementado aquí porque las pantallas sobre Leaflet no
 * cargan el SDK de Google Maps y no compensa añadir una dependencia para 30
 * líneas de bit-shifting.
 *
 * Precisión fija de 1e-5, que es la que usa el formato estándar.
 */
export function decodePolyline(encoded: string): [number, number][] {
  const points: [number, number][] = [];
  let index = 0;
  let lat = 0;
  let lng = 0;

  while (index < encoded.length) {
    lat += decodeSignedValue();
    lng += decodeSignedValue();
    points.push([lat / 1e5, lng / 1e5]);
  }

  return points;

  /**
   * Cada coordenada se guarda como diferencia con la anterior, en grupos de 5
   * bits con el bit 0x20 marcando "sigue otro grupo", y con el signo en el bit
   * menos significativo del resultado.
   */
  function decodeSignedValue(): number {
    let result = 0;
    let shift = 0;
    let byte: number;
    do {
      byte = encoded.charCodeAt(index++) - 63;
      result |= (byte & 0x1f) << shift;
      shift += 5;
    } while (byte >= 0x20 && index < encoded.length);
    return result & 1 ? ~(result >> 1) : result >> 1;
  }
}
